import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useHttp from "hooks/use-http";

import { Button, Grid } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  getcommentByIdRequest,
  deletecommentRequest,
  confirmcommentRequest,
} from "api/requests";

import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";
import DeleteModal from "components/shared/Modal/Delete";
import Toast from "helper/toast";

import {
  StyledStack,
  StyledTitle,
  TextField,
  ButtonContainer,
} from "./MessageDetails.style";

export default function MessageDetails() {
  const navigate = useNavigate();
  const params = useParams();
  const { request, loading, setLoading } = useHttp();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [messageInfo, setMessageInfo] = useState({ data: [], count: 0 });
  const [jDate, setJDate] = useState("");

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const getMessageInfo = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getcommentByIdRequest,
      values: params.messageId,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setMessageInfo({
          count: res.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      setMessageInfo(res);
      setJDate(res.created_at.jdate.split(" ")[0]);
    }
  }, [request, params.complaintId]);

  useEffect(() => {
    getMessageInfo();
  }, [getMessageInfo]);

  const onDelete = async () => {
    const res = await request({
      url: deletecommentRequest,
      values: params.messageId,
    });

    if (res) {
      Toast({ type: "success", title: "حذف نظر" });
      navigate("/comment");
    }
  };

  const onAccept = async () => {
    const res = await request({
      url: confirmcommentRequest,
      values: params.messageId,
    });

    if (res) {
      Toast({ type: "success", title: "تایید نظر" });
      // navigate("/comment");
    }
  };

  return (
    <DrawerCM title="نمایش نظر">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>نمایش جزئیات نظر</StyledTitle>
              <Grid container>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>نام و نام خانوادگی :</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo?.user?.full_name}
                    </div>
                  </TextField>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}> شماره تماس : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo?.user?.phone_number}
                    </div>
                  </TextField>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>تاریخ ارسال : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>{jDate}</div>
                  </TextField>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>موضوع نظر : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.title}
                    </div>
                  </TextField>
                </Grid>
                <Grid item xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>متن نظر : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.text}
                    </div>
                  </TextField>
                </Grid>
              </Grid>
              <ButtonContainer>
                <Button
                  color="error"
                  startIcon={<DeleteIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handelShowModal}
                >
                  حذف
                </Button>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={onAccept}
                >
                  تایید
                </Button>
              </ButtonContainer>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onDelete}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
